import api from './api';
import serviceConfig from '../config/serviceConfig';

class HealthService {
  async getSystemHealth() {
    try {
      const response = await api.get('/api/super-admin/health/system');
      return response.data;
    } catch (error) {
      console.error('Error fetching system health:', error);
      throw error;
    }
  }

  async getServiceHealth(serviceName) {
    try {
      const response = await api.get(`/api/super-admin/health/${serviceName}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching ${serviceName} health:`, error);
      throw error;
    }
  }

  getStatusColor(status) {
    switch (status?.toUpperCase()) {
      case 'UP':
        return '#10b981'; // green
      case 'DOWN':
        return '#ef4444'; // red
      case 'DISABLED':
        return '#6b7280'; // gray
      default:
        return '#f59e0b'; // yellow
    }
  }

  getStatusIcon(status) {
    switch (status?.toUpperCase()) {
      case 'UP':
        return '✅';
      case 'DOWN':
        return '❌';
      case 'DISABLED':
        return '⚪';
      default:
        return '⚠️';
    }
  }

  formatServiceName(serviceName) {
    return serviceConfig.getServiceNameById(serviceName) || serviceName;
  }

  // Get service endpoint by name
  getServiceEndpoint(serviceName) {
    const service = serviceConfig.getServiceById(serviceName);
    return service ? service.endpoint : serviceName;
  }
}

export default new HealthService();
